(() => {
    'use strict';

    howspace.widgets.lesson = {
        initView: widget => {
            // During duplication files are stored asynchronously. Lesson widget extracts and stores each file from the
            // package zip separately. Thus, we don't listen to individual files being stored, but
            // "workspace:duplication:s3sync:completed" event which is triggered when all S3 files have been stored.
            real.events.on('workspace:duplication:s3sync:completed', () => {
                // Reload each lesson widget which was not yet ready to show the iframe before.
                $('.widget-lesson[data-is-ready-to-show-iframe="false"]').each(function() {
                    howspace.widgets.updateWidget($(this), 'view');
                });
            });

            real.events.on('widget:duplication:s3sync:completed', notification => {
                if (widget.data('widget-id') === notification.object.widget.id) {
                    howspace.widgets.updateWidget(widget, 'view');
                }
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Delete file button
            widget.on('click', '.delete-file-btn', (e) => {
                const file = $(e.target).closest('.file');
                file.velocity('slideUp', 'fast', () => file.remove());

                widget.find('.add-file-btn').prop('disabled', false);
            });

            // Embed height input
            const embedHeightInput = widget.find('input[name="embed_height"]');

            embedHeightInput.on('input blur', () => {
                // Validate the embed height input so that it contains only numbers and possibly a percentage character.
                let embedHeightVal = embedHeightInput.val().trim().replace(/[^0-9.,%]/gi, '');
                embedHeightVal = embedHeightVal.replace(/,/gi, '.');
                embedHeightVal = embedHeightVal.replace(/\.+/gi, '.');
                embedHeightVal = embedHeightVal.replace(/%+/gi, '%');

                if (embedHeightInput.val() !== embedHeightVal) {
                    embedHeightInput.val(embedHeightVal);
                }
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        initFileUploaderModal: (modal, modalOpener) => {
            const widget = $(modalOpener).closest('.widget');

            modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
                howspace.widgets.lesson.handleFileUploadCompleted(modal, e.detail.uploadedFiles[0], widget);
            });
        },
        handleFileUploadCompleted: (modal, uploadedFile, widget) => {
            if (widget.data('widget-mode') === 'view') {
                const dataPayload = {
                    package_file: uploadedFile.id
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type : 'POST',
                    data : JSON.stringify(dataPayload)
                });
            } else {
                real.ajax.html(howspace.widgets.getUrl(widget) + '/file/' + uploadedFile.id, {
                    type : 'GET',
                    success : function(response) {
                        const file = $(response);
                        widget.find('.files').append(file);

                        widget.find('.add-file-btn').prop('disabled', true);
                    }
                });
            }

            howspace.components.modal.close(modal);
        }
    };
})();
